import { styled } from 'parkdepot-shared/theme'

export const Wrapper = styled('div', ({ $theme }) => ({
    marginTop: '0.8rem',
    width: '100%'
}))

export const OptionIcon = styled('i', () => ({
    fontSize: '1.6rem'
}))

export const SelectArrow = styled('i', ({ $theme }) => ({
    fontSize: '1.6rem',
    cursor: 'pointer'
}))

export const FormPlateInputWrapper = styled('div', {
    marginTop: '8px'
})

export const ValueLabelWrapper = styled('div', () => ({
    color: '#1F1F1F',
    display: 'flex',
    gap: '8px',
    alignItems: 'center'
}))

export const OptionLabel = styled('span', () => ({
    fontSize: '1.6rem'
}))

export const OptionLabelWrapper = styled<'div', { $primaryColor: boolean; $disabled: boolean }>(
    'div',
    ({ $theme, $primaryColor, $disabled }) => ({
        ...$theme.typography.ParagraphMedium,
        display: 'flex',
        gap: '8px',
        alignItems: 'center',
        color: $primaryColor ? $theme.colors.primary : '#1F1F1F',
        opacity: $disabled ? 0.4 : 1
    })
)

export const SelectOverrides = {
    Root: {
        style: {
            border: '1px solid #E2E2E2',
            borderRadius: '10rem',
            paddingLeft: '0.6rem'
        }
    },
    ControlContainer: {
        style: {
            // sometimes baseui bugs it out here and shows multiple borders, this should do the trick for now
            backgroundColor: '#fff',
            border: '1px solid #E2E2E2',
            borderLeftColor: 'transparent !important',
            borderRightColor: 'transparent !important',
            borderTopColor: 'transparent !important',
            borderBottomColor: 'transparent !important'
        }
    },
    DropdownListItem: {
        style: {
            ':hover': {
                backgroundColor: '#EFF3FE'
            }
        }
    },
    Input: {
        style: {}
    },
    Placeholder: {
        style: {
            fontSize: '1.35rem',
            color: '#B3BBC7'
        }
    },
    DropdownContainer: {
        style: {
            // weird baseweb behaviour because of the borders.
            // otherwise the dropdown is not aligned with the input
            marginLeft: '3px'
        }
    }
}
